module.exports = __webpack_public_path__ + "media/snowballvid.28de6385.mp4";